<template>
    <!-- Content area -->
    <div class="content pb-20">
        <form @submit.prevent="login()">
        <!-- Advanced login -->
        <div id="loginForm">
            <div class="panel panel-body login-form">
                <div class="text-center">
                    <p class=""><img style="max-height: 100px; display: inline-block;" src="//saad.thirty3.tools/images/logo.jpg" alt=""></p>
                    <h5 class="content-group-lg">Login to your account <small class="display-block">Enter your credentials</small></h5>
                </div>

                <div class="form-group has-feedback has-feedback-left">
                    <input type="text" class="form-control" placeholder="Email" v-model="username">
                    <div class="form-control-feedback">
                        <i class="icon-user text-muted"></i>
                    </div>
                </div>

                <div class="form-group has-feedback has-feedback-left">
                    <input type="password" class="form-control" placeholder="Password" v-model="password">
                    <div class="form-control-feedback">
                        <i class="icon-lock2 text-muted"></i>
                    </div>
                </div>

                <div class="form-group login-options">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="checkbox-inline">
                                <input type="checkbox" class="styled" checked="checked">
                                Remember
                            </label>
                        </div>

                        <div class="col-sm-6 text-right">
                            <a href="">Forgot password?</a>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <button type="submit" class="btn bg-green-400 btn-block">Login <i class="icon-arrow-right14 position-right"></i></button>
                    <div v-if="response" class="text-red">{{response}}</div>
                </div>

                <div class="content-divider text-muted form-group"><span>or sign in with</span></div>
                <ul class="list-inline form-group list-inline-condensed text-center">
                    <li><a href="" class="btn border-indigo text-indigo btn-flat btn-icon btn-rounded"><i class="icon-facebook"></i></a></li>
                    <li><a href="" class="btn border-pink-300 text-pink-300 btn-flat btn-icon btn-rounded"><i class="icon-dribbble3"></i></a></li>
                    <li><a href="" class="btn border-slate-600 text-slate-600 btn-flat btn-icon btn-rounded"><i class="icon-github"></i></a></li>
                    <li><a href="" class="btn border-info text-info btn-flat btn-icon btn-rounded"><i class="icon-twitter"></i></a></li>
                </ul>

                <div class="content-divider text-muted form-group"><span>Don't have an account?</span></div>
                <a href="" class="btn btn-default btn-block content-group">Sign up</a>
                <span class="help-block text-center no-margin">By continuing, you're confirming that you've read our <a href="">Terms &amp; Conditions</a> and <a href="">Cookie Policy</a></span>
            </div>
        </div>
        <!-- /advanced login -->
        </form>
    </div>
    <!-- /content area -->
</template>

<script>
import AuthService from '@/services/auth.service'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      loading: '',
      response: ''
    }
  },
  created () {
    if (this.$store.getters.isLoggedIn) {
      this.$router.replace({ name: 'dashboard' })
    } else {
    }
  },
  methods: {
    toggleLoading: function () {
      this.loading = (this.loading === '') ? 'loading' : ''
    },
    resetResponse: function () {
      this.response = ''
    },
    login () {
      AuthService.login({
        username: this.username,
        password: this.password
      }, (data) => {
        this.$store.dispatch('login', data).then(() => {
          this.$router.push('/')
        })
      }, () => {
        this.$popup.warning('Wrong credentials or server error...')
      })
    }
  }
}
</script>

<style scoped>

</style>
